export default function BookDetailsPage() {
  return null;
}
